import {InfiniteData} from '@tanstack/query-core';
import {useEffect} from 'react';
import {CommentItem, CommentListQuery} from '../../../graphql/generated/types';
import {useLogin} from '../../../user/useLogin.hook';
import {useBlockUserListQuery} from '../../../wrapper';
import {updateEmoticon} from '../util/updateEmoticon';

export function useUpdateCommentEmoticon({
  commentList,
}: {
  commentList: InfiniteData<CommentListQuery> | CommentItem | undefined;
}) {
  const {isLogin} = useLogin();
  const {list: blockUserList} =
    useBlockUserListQuery(undefined, {
      enabled: isLogin,
    }).data?.blockUserList || {};
  useEffect(() => {
    updateEmoticon();
  }, [commentList, blockUserList]);
}
